import { loadable } from 'utils';

export const Installation = loadable(() => import('./Installation'), {});
export const Settings = loadable(() => import('./Settings'), {});
